import React from 'react';
import {Column} from 'devextreme-react/data-grid';
import {Item as TabItem} from "devextreme-react/tab-panel";
import Form, {GroupItem, SimpleItem, Label} from "devextreme-react/form";
import IMetier from "../../models/IMetier";
import {FormListBase, FormListBaseTab, FormListBaseGrid} from '../base';
import {} from 'devextreme-react';
import useCustomDataSource, {Mode} from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';

export default function PaieMetiers() {
    const metierFormDataSource = useCustomDataSource<IMetier, IMetier>({path: "metier", primaryKey: "idMetier", customReadAllPath: "metier/read-list"});
    const {selectedDataRow: selectedMetier, mode, setMode, isFieldModifier, setIsFieldModifier} = metierFormDataSource;

    return (
        <FormListBase data={metierFormDataSource}>
            <FormListBaseGrid dataSource={metierFormDataSource.dataSource}>
                <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false}/>
                <Column key={"grid-col-code"} dataField={"code"} caption="Code" allowHiding={false}/>
            </FormListBaseGrid>
            <FormListBaseTab>
                <TabItem title="Informations">
                    <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedMetier || {} as IMetier} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
                        <GroupItem alignItemLabels={true}>
                            <GroupItem>
                                <SimpleItem key={"frm-description"} dataField={"description"}/>
                                <SimpleItem key={"frm-code"} dataField={"code"}/>
                            </GroupItem>
                        </GroupItem>
                    </Form>
                </TabItem>
                <TabItem title="Système"><FormSysteme formData={selectedMetier || {} as IMetier}/></TabItem>
            </FormListBaseTab>
        </FormListBase>
    );
}